// AKA Base Solution
// Version 1.1
//
// Authors: Vinicius Artioli, Catia Melo, Tony Possamai, Chris Muldoon, Josh Winterbottom, Jeremy Basolo,Sam Johnson, Aung Myo Win


import "../scss/styles.scss";

import "jquery";
window.$ = jQuery;

import 'bootstrap';
import '@popperjs/core';

// COMMON
import "./common/header";
import "./common/lazy-videos";
//import "./common/widont"; // to remove widows/orphans

// BLOCKS
import "./blocks/block-cards-image";
// import "./blocks/block-cards-news";
// import "./blocks/block-carousel-and-text";
import "./blocks/block-cast-and-creative";
import "./blocks/block-gallery-global";
// import "./blocks/block-gallery-scroller";
// import "./blocks/block-hero-carousel-global";
import "./blocks/block-quote-slider";
// import "./blocks/block-tabs";
// import "./blocks/block-text-and-thumbnails";
// import "./blocks/block-ticket-calendar-carousel";
import "./blocks/block-hero-image";
import "./blocks/block-video";
import "./blocks/block-tour-dates";



$(function () {
	$("body").removeClass("loading");
});

